<template>
  <select-filter v-model="selectedColsList" :items="cols" item-value="id" item-title="label" :label="$t('MULTIPROJECTS.COLUMNS')"
                 multiple :menu-props="{ location: 'bottom' }">
    <template #selection="{ index }">
      <span v-if="index === 0">{{ selectedColsList.length }}/{{ cols.length }}</span>
    </template>
  </select-filter>
</template>

<script>
  import { mapState } from 'pinia';
  import useMultiprojectsStore from '@/stores/multiprojects/multiprojects';

  export default {
    props: {
      cols: { type: Array, default: () => [] },
    },
    computed: {
      selectedColsList: {
        get() {
          return this.cols.filter(col => this.progressOptions.selectedCols[col.id]);
        },
        set(newVal) {
          this.cols.forEach((col) => {
            this.progressOptions.selectedCols[col.id] = newVal.includes(col.id);
          });
        },
      },
      ...mapState(useMultiprojectsStore, ['progressOptions']),
    },
    watch: {
      cols: {
        handler() {
          this.cols.forEach((col) => {
            if (! Object.prototype.hasOwnProperty.call(this.progressOptions.selectedCols, col.id)) {
              this.progressOptions.selectedCols[col.id] = true;
            }
          });
        },
        immediate: true,
      },
    },
  };
</script>
